import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { getLoginInform } from 'function/login';
import { ROUTER_PATH } from 'types/const';
import { RETURN_YN } from 'types/type';
import format from 'utils/string/format';

import AuthLayout from 'layouts/AuthLayout';

import Dashboard from 'components/pages/sfms/dashboard/main/Content';
import DashboardTrend from 'components/pages/sfms/dashboard/trend/Content';

import RawMaterialPrice from 'components/pages/sfms/rawMaterial/price/List';
import RawMaterialNutrition from 'components/pages/sfms/rawMaterial/nutrition/List';
import ProductOutput from 'components/pages/sfms/product/output/List';
import MixOutput from 'components/pages/sfms/mix/output/List';

import MixRatio from 'components/pages/sfms/mix/ratio/List';
import ProductNutrition from 'components/pages/sfms/product/nutrition/List';

import ReportList from 'components/pages/sfms/report/List';
import SetReportIOMC from 'components/pages/sfms/report/iomc/Setting';
import ReportIOMCInform from 'components/pages/sfms/report/iomc/Inform';
import ReportAnalysisQualityRawMaterialInform from 'components/pages/sfms/report/analysis/quality/rawMaterial/Inform';
import ReportAnalysisQualityProductInform from 'components/pages/sfms/report/analysis/quality/product/Inform';

import BoardNoticeList from 'components/pages/board/notice/List';
import BoardNoticeInform from 'components/pages/board/notice/Inform';
import BoardRawMaterialList from 'components/pages/board/rawMaterial/List';
import BoardRawMaterialInform from 'components/pages/board/rawMaterial/Inform';
import BoardFile from 'components/pages/board/file/List';
import BoardQnA from 'components/pages/board/qna/List';
import BoardQnAInform from 'components/pages/board/qna/Inform';

import StandardCode from 'components/pages/standard/code/List';
import StandardMixCode from 'components/pages/standard/code/mix/List';
import StandardRawMaterialCode from 'components/pages/standard/code/rawMaterial/List';
import StandardProductCode from 'components/pages/standard/code/product/List';

import AdminList from 'components/pages/admin/List';
import SetAdmin from 'components/pages/admin/Setting';

import MyPage from 'components/pages/sfms/MyPage';

/**
 * SFMS 라우터
 */
const SFMSRoutes = () => {
  const { adminYn } = getLoginInform();

  return (
    <Switch>
      {/* 로그인 */}
      <Route path={ROUTER_PATH.login} exact component={AuthLayout} />

      {/* 대시보드 */}
      <Route
        path={ROUTER_PATH.sfms.dashboard.main}
        exact
        component={Dashboard}
      />
      <Route
        path={ROUTER_PATH.sfms.dashboard.trend}
        exact
        component={DashboardTrend}
      />

      {/* 배합비 작성 정보 관리 */}
      <Route
        path={ROUTER_PATH.sfms.rawMaterial.price}
        exact
        component={RawMaterialPrice}
      />
      <Route
        path={ROUTER_PATH.sfms.rawMaterial.nutrition}
        exact
        component={RawMaterialNutrition}
      />
      <Route
        path={ROUTER_PATH.sfms.product.output}
        exact
        component={ProductOutput}
      />
      <Route path={ROUTER_PATH.sfms.mix.output} exact component={MixOutput} />

      {/* 배합비 등록 관리 */}
      <Route path={ROUTER_PATH.sfms.mix.ratio} exact component={MixRatio} />
      <Route
        path={[ROUTER_PATH.sfms.product.nutrition, ROUTER_PATH.sfms.monitoring]}
        exact
        component={ProductNutrition}
      />

      {/* 리포트 */}
      <Route
        path={format(ROUTER_PATH.sfms.report.list, { type: ':type' })}
        exact
        component={ReportList}
      />
      <Route
        path={format(ROUTER_PATH.sfms.report.iomc.setting, {
          type: ':type',
          iomcYm: ':iomcYm',
          buCode: ':buCode'
        })}
        exact
        component={SetReportIOMC}
      />
      <Route
        path={format(ROUTER_PATH.sfms.report.iomc.inform, {
          type: ':type',
          iomcYm: ':iomcYm',
          buCode: ':buCode',
          seq: ':seq?'
        })}
        exact
        component={ReportIOMCInform}
      />
      <Route
        path={format(ROUTER_PATH.sfms.report.analysis.quality.rawMaterial, {
          type: ':type',
          reportYm: ':reportYm',
          factoryCodeSeq: ':factoryCodeSeq',
          seq: ':seq'
        })}
        exact
        component={ReportAnalysisQualityRawMaterialInform}
      />
      <Route
        path={format(ROUTER_PATH.sfms.report.analysis.quality.product, {
          type: ':type',
          reportYm: ':reportYm',
          factoryCodeSeq: ':factoryCodeSeq',
          seq: ':seq'
        })}
        exact
        component={ReportAnalysisQualityProductInform}
      />

      {/* 협업 게시판 */}
      <Route
        path={ROUTER_PATH.board.notice.list}
        exact
        component={BoardNoticeList}
      />
      <Route
        path={[
          format(ROUTER_PATH.board.notice.setting, { seq: ':seq?' }),
          format(ROUTER_PATH.board.notice.inform, { seq: ':seq' })
        ]}
        exact
        component={BoardNoticeInform}
      />
      <Route
        path={ROUTER_PATH.board.rawMaterial.list}
        exact
        component={BoardRawMaterialList}
      />
      <Route
        path={[
          format(ROUTER_PATH.board.rawMaterial.setting, { seq: ':seq?' }),
          format(ROUTER_PATH.board.rawMaterial.inform, { seq: ':seq' })
        ]}
        exact
        component={BoardRawMaterialInform}
      />
      <Route path={ROUTER_PATH.board.file} exact component={BoardFile} />
      <Route path={ROUTER_PATH.board.qna.list} exact component={BoardQnA} />
      <Route
        path={[
          format(ROUTER_PATH.board.qna.setting, { seq: ':seq?' }),
          format(ROUTER_PATH.board.qna.inform, { seq: ':seq' })
        ]}
        exact
        component={BoardQnAInform}
      />

      {/* 기준 정보 */}
      <Route
        path={ROUTER_PATH.standard.code.default}
        exact
        component={StandardCode}
      />
      <Route
        path={ROUTER_PATH.standard.code.mix}
        exact
        component={StandardMixCode}
      />
      <Route
        path={ROUTER_PATH.standard.code.rawMaterial}
        exact
        component={StandardRawMaterialCode}
      />
      <Route
        path={ROUTER_PATH.standard.code.product}
        exact
        component={StandardProductCode}
      />

      {/* 마이 페이지 */}
      <Route path={ROUTER_PATH.myPage} exact component={MyPage} />

      {/* 관리자 페이지 */}
      {adminYn === RETURN_YN.Y && (
        <>
          <Route path={ROUTER_PATH.admin.list} exact component={AdminList} />
          <Route
            path={format(ROUTER_PATH.admin.setting, { seq: ':seq?' })}
            exact
            component={SetAdmin}
          />
        </>
      )}

      {/* Redirect */}
      <Redirect to="/errors/404" />
    </Switch>
  );
};

export default SFMSRoutes;
